var ur = window.location.href;
if(ur.includes('/product')){
    
const checkExist = setInterval(() => {
    
  const targets = [
    {
      selector: '#infiniteoptions-container fieldset [name*="Installation"]',
      labelText: "I don't need  installation",
      value: "I don't need installation",
      className: "no-delivery-option",
    },
    {
      selector: '#infiniteoptions-container fieldset [name*="Dirt Removal"]',
      labelText: "I don't need dirt removal",
      value: "I don't need dirt removal",
      className: "no-dirtremoval-option",
    },
  ];

  let allFound = true;

  targets.forEach((opt) => {
    const target = document.querySelector(opt.selector);

    if (target) {
      // Prevent duplicates
      if (target.closest('fieldset').querySelector(`.${opt.className}`)) return;

      document.querySelectorAll('#infiniteoptions-container fieldset [name*="Installation"]')
        .forEach((el) => {
          const span = el.closest('span');
          const prev = span?.previousElementSibling;
          const label = prev?.querySelector('label');
          if (label) label.innerHTML = 'Installation';
        });

      // Create and insert label
      const label = document.createElement('label');
      label.innerHTML = `
        <input type="checkbox" 
               value="${opt.value}" 
               class="spb-productoptiontextcolor spb-productoptionbackground ${opt.className} auto-select">
        ${opt.labelText}
      `;
      target.insertAdjacentElement('afterend', label);
    } else {
      allFound = false;
    }
    if (allFound) clearInterval(checkExist);
  });
  
  const fieldsets = document.querySelectorAll('#infiniteoptions-container > div:not(.accessories_with_image) fieldset');

  if (fieldsets.length) {

    fieldsets.forEach((fieldset) => {
      const checkboxes = fieldset.querySelectorAll('input[type="checkbox"]');
      if (!checkboxes.length) return;

      // Auto-select "no delivery" if present
      const autoSelects = document.querySelectorAll('.auto-select');
    autoSelects.forEach((el) => (el.checked = true));   


      // Ensure only one checkbox per fieldset
      checkboxes.forEach((cb) => {
        cb.addEventListener('change', () => {
          if (cb.checked) {
            checkboxes.forEach((other) => {
              if (other !== cb) other.checked = false;
            });
          }
        });
      });
    });
  }

  setInterval(() => {
  const deliveryHidden = document.querySelector('#delivery-property');
  const dirtHidden = document.querySelector('#dirt-removal-property');

  const noDelivery = document.querySelector('input.no-delivery-option');
  const noDirt = document.querySelector('input.no-dirtremoval-option');

  // --- Delivery ---
  if (deliveryHidden) {
    if (noDelivery && noDelivery.checked) {
      deliveryHidden.value = noDelivery.value;
    } else {
      deliveryHidden.value = '';
    }
  }

  // --- Dirt Removal ---
  if (dirtHidden) {
    if (noDirt && noDirt.checked) {
      dirtHidden.value = noDirt.value;
    } else {
      dirtHidden.value = '';
    }
  }
}, 300);



  
}, 300);

 
}